import React, { FC, memo } from "../../../lib/teact/teact";
import { tienFormat } from "../utils/NumberUtils";
import { isCuPhapMn } from "../utils/common";
import './ItemDataCanChuyen.scss'
type OwnProps = {
    row: any;
    diemByStt: any;
    index: number;
    dataCanChuyen: any;
}

const ItemDataCanChuyen: FC<OwnProps> = ({
    row,
    diemByStt,
    index,
    dataCanChuyen,
}) => {
    //let thua = getThua(row, diemByStt, dataCanChuyen)
    return (
        <div className="item-data"  >
            {isCuPhapMn() ?
                <div>
                    {row.daiId1}.{row.daiId2}
                </div>
                : <div className="stt">
                    {index}
                </div>
            }
            <div>
                {row.loaiCuocId}
            </div>
            <div>
                {row.soCuoc}
            </div>
            <div className="nhan">
                {tienFormat(row.diemGiuLai)}
            </div>
            <div className="thua">
                {tienFormat(row.thua,1)}
            </div>
        </div>
    )
}
export default memo(ItemDataCanChuyen)